(function() {
  var accordion = function() {
    $('.pdp-accordion-wrapper').find('.pdp-accordion-toggle').click(function(){

      if(false == $(this).parent().find('.pdp-accordion-content').is(':visible')) {
        $('.pdp-accordion-wrapper .pdp-accordion-toggle').removeClass('active');
        $('.pdp-accordion-wrapper .pdp-accordion-content').slideUp();
      }

      $(this).toggleClass('active');
      $(this).parent().find('.pdp-accordion-content').slideToggle('fast');
    });
  };

  accordion();

  $(document).on('shopify:section:load', function(event) { 
    accordion();
  });
})();
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".reviewSwiper", {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    autoHeight: true,
    pagination: {
      el: ".reviewSwiper-pagination",
      clickable: true
    },
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false
    // }
  });
});
jQuery(function() {
 
    $(document).on("click", ".js__pdp-variant-select li", function() {

        setTimeout(function() {
            if ($(".rc_block__type--active").html() != undefined) {
                var price = $(".rc_block__type--active").find(".rc_price").html();

                $(".js__modal-popup-add-to-cart-price").html(price);

            }
        }, 100);
    })

    $(document).on("click", ".rc_block__type--active", function() {

        var id = $(this).attr("data-id");
        var price = $(".js__rc_block__type__onetime-" + id).find(".rc_price__onetime").html();
        $(".modal-popup-price-" + id).html(price)


    })
    $(document).on("click", ".rc_block__type-modal-popup", function() {
        var productID = $(this).attr("data-id");

        var price = $(this).children("label").children(".rc_price").html();

        $(".modal-popup-price-" + productID).html(price)
        $(".rc_block__type-modal-popup").removeClass("rc_block__type--active");
        $(this).addClass("rc_block__type--active");
        var option = $(".js__popup-variant-select-" + productID + " li.active").html();
        if (option == undefined) {
            if ($(this).hasClass("rc_block__type__onetime")) {
                var vID = $("#product-select-" + productID).val();
                $(".js__modal-popup-addtocart-" + productID).attr("data-variant-id", vID);
            } else {
                var vID = $(".discount_variant-" + productID).children("span").attr("pl-discounted-variant-id");
                $(".js__modal-popup-addtocart-" + productID).attr("data-variant-id", vID);
                $(".modal-popup-price-subcription-" + productID).html($(".discount_variant-" + productID).children("span").html());
            }

        } else {
            if ($(this).hasClass("rc_block__type__onetime")) {
                $("#product-select-" + productID + " option").each(function(index) {
                    var optionName = $(this).html();
                    var vID = $(this).attr("value");
                    var price = $(this).attr("data-price");
                    if (optionName == option) {
                        $(".js__modal-popup-addtocart-" + productID).attr("data-variant-id", vID);
                        $(".js__rc_block__type__onetime-" + productID).find(".rc_price__onetime").html(price)
                    }
                })
            } else {
                console.log("else")
                console.log(option);
                $("#product-select-" + productID + " option").each(function(index) {
                    var optionName = $(this).html();
                    var vID = $(this).attr("value");
                    var price = $(this).attr("data-price");
                    console.log(optionName);
                    if (optionName == option) {

                        console.log("if2")
                        $(".discount_variant-" + productID + " span").each(function(index) {

                            var variantID = $(this).attr("vid");

                            if (variantID == vID) {
                                console.log("if3")
                                $(".modal-popup-price-subcription-" + productID).html($(".js__popup-variant-price-" + vID).html());
                                var discountVariantID = $(this).attr("pl-discounted-variant-id");
                                $(".js__modal-popup-addtocart-" + productID).attr("data-variant-id", discountVariantID);
                            }

                        })



                    }
                })

            }
        }

    });
  
  //------------------------------------------ Quiz Functionality ------------------------------------------------------

  //remove all extra quiz slides
  if (!Shopify.designMode) {
    $('.quizSlide').each(function(){
      var thisThing = $(this);
      if (thisThing.find('.quizQuestion__title').text().trim() == '' && !thisThing.hasClass('quizSlide--landing') && !thisThing.hasClass('quizSlide--emailCollection')){
        thisThing.remove();
      }
    });
  }

  //set quiz length text and final slide to a number
  var quizCount = $('.quizSlide').last().prev().attr('data-slide') * 1;
  $('.quizQuestion__totalSlides').text(quizCount);
  $('.quizSlide').last().attr('data-slide', quizCount + 1);

  //hide the controls on load
  $('.quizControls').hide();

  //function to slide quiz to correct page, handle all state changes needed
  function quizSlideTo(index){
    //show hide controls and change slider height based on slide
    var nextSlide = $('.quizSlide[data-slide="'+index+'"]');
    
    if (index == 0){
      $('.quiz').attr('style', 'height:auto;');
      $('.quizControls').slideUp();
    }
    else{
      if ($(window).width() > 999) {
        $('.quiz').attr('style', 'height:750px;');
      }
      else{
        var newHeight = nextSlide.find('.quizQuestion__inner').innerHeight();
        $('.quiz').attr('style', 'height:'+newHeight+'px;');
      }
      $('.quizControls').slideDown();
    }
    //move to slide and set active class
    
    var offset = -100 * index;
    $('.quiz__frame').attr('style', 'transform:translateX('+offset+'vw);');
    $('.quizSlide').removeClass('quizSlide--active');
    nextSlide.addClass('quizSlide--active');

    // enable disable prev button
    if (index > 1){
      $('.quizControls__button--prev').removeClass('quizControls__button--disabled');
      $('.quizQuestion__prev').removeClass('quizQuestion__controlButton--disabled');
    }
    else{
      $('.quizControls__button--prev').addClass('quizControls__button--disabled');
      $('.quizQuestion__prev').addClass('quizQuestion__controlButton--disabled');
    }
    //disable next button if next slide has nothing selected
    if (!nextSlide.find('.quizQuestion__radioAnswer--active, .quizQuestion__selectAnswer--active').length >= 1){
      $('.quizControls__button--next').addClass('quizControls__button--disabled');
      $('.quizQuestion__next').addClass('quizQuestion__controlButton--disabled');
    }
    else{
      $('.quizControls__button--next').removeClass('quizControls__button--disabled');
      $('.quizQuestion__next').removeClass('quizQuestion__controlButton--disabled');
    }

    //show hide skip button if on last slide
    var quizCount = $('.quizSlide').last().attr('data-slide') * 1;

    $('.quizControls__progress').attr('style', 'width:calc((100% / '+quizCount+') * '+index+')')

    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  //start button slide to first real slide
  $('.quizButton--start').on('click', function(){
    quizSlideTo(1);
  });
  
  //close button sends to first slide
  $('.quizQuestion__close').on('click', function(){
    quizSlideTo(0);
  });

  //on click of a radio answer remove active class from others and assign to clicked
  $('.quizQuestion__radioAnswer').on('click', function(){
    var container = $(this).parent();
    container.find('.quizQuestion__radioAnswer').removeClass('quizQuestion__radioAnswer--active');
    $(this).addClass('quizQuestion__radioAnswer--active');

    if (container.find('.quizQuestion__radioAnswer--active').length >= 1){
      $('.quizControls__button--next').removeClass('quizControls__button--disabled');
      $('.quizQuestion__next').removeClass('quizQuestion__controlButton--disabled');
    }
    else{
      $('.quizControls__button--next').addClass('quizControls__button--disabled');
      $('.quizQuestion__next').addClass('quizQuestion__controlButton--disabled');
    }
  });

  //on click multi select toggles on and off of active class
  $('.quizQuestion__selectAnswer').on('click', function(){
    var container = $(this).parent();
    if ($(this).hasClass('quizQuestion__selectAnswer--active')){
      $(this).removeClass('quizQuestion__selectAnswer--active');
    }
    else{
      $(this).addClass('quizQuestion__selectAnswer--active');
    }

    if (container.find('.quizQuestion__selectAnswer--active').length >= 1){
      $('.quizControls__button--next').removeClass('quizControls__button--disabled');
      $('.quizQuestion__next').removeClass('quizQuestion__controlButton--disabled');
    }
    else{
      $('.quizControls__button--next').addClass('quizControls__button--disabled');
      $('.quizQuestion__next').addClass('quizQuestion__controlButton--disabled');
    }
  });

  //next button takes you to next slide
  $('.quizControls__button--next').on('click', function(){
    if (!$(this).hasClass('quizControls__button--disabled')){
      var currentSlide = $('.quizSlide--active').attr('data-slide') * 1;
      var nextSlide = currentSlide + 1;
      quizSlideTo(nextSlide);
    }
  });

  $('.quizQuestion__next').on('click', function(){
    if (!$(this).hasClass('quizQuestion__controlButton--disabled')){
      var currentSlide = $('.quizSlide--active').attr('data-slide') * 1;
      var nextSlide = currentSlide + 1;
      quizSlideTo(nextSlide);
    }
  });

  //previous button takes you to previous slide
  $('.quizControls__button--prev').on('click', function(){
    if (!$(this).hasClass('quizControls__button--disabled')){
      var currentSlide = $('.quizSlide--active').attr('data-slide') * 1;
      var prevSlide = currentSlide - 1;
      quizSlideTo(prevSlide);
    }
  });
  
  $('.quizQuestion__prev').on('click', function(){
    if (!$(this).hasClass('quizQuestion__controlButton--disabled')){
      var currentSlide = $('.quizSlide--active').attr('data-slide') * 1;
      var prevSlide = currentSlide - 1;
      quizSlideTo(prevSlide);
    }
  });

  function checkArrayForHandle(array, handle){
    return array.some(function(el) {
      return el.handle === handle;
    });
  }

  function getProdScores(attr){
    var answerLib = [];
    $('.quizQuestion__radioAnswer--active, .quizQuestion__selectAnswer--active').each(function(){
      var weight = $(this).attr('data-weight') * 1;
      var handleArray = $(this).attr(attr).split(',');
      for (i=0;i<handleArray.length;i++){
        if (checkArrayForHandle(answerLib, handleArray[i])){
          var result = answerLib.filter(obj => {
            return obj.handle === handleArray[i]
          });
          result.points += weight;
        }
        else{
          if (handleArray != ''){
            var prodObj = {
              handle: handleArray[i],
              points: weight
            };
            answerLib.push(prodObj);
          }
        }
      }
    });
    
    answerLib.sort((a, b) => parseFloat(a.points) - parseFloat(b.points));
    answerLib.reverse();
    console.log(answerLib);
    return answerLib;
  }
  
  function getExcludedList(){
    var excludeLib = [];
    $('.quizQuestion__radioAnswer--active, .quizQuestion__selectAnswer--active').each(function(){
      if ($(this).attr('data-excluded-prods').trim() != ''){
        var handleArray = $(this).attr('data-excluded-prods').split(',');
        for (i=0;i<handleArray.length;i++){
          if (!excludeLib.includes(handleArray[i])){
            excludeLib.push(handleArray[i]);
          }
        }
      }
    });
    return excludeLib;
  }

  function getRecommendedProducts(){
    var excludeLib = getExcludedList();
    var oneAnswers = getProdScores('data-one-prods');
    var twoAnswers = getProdScores('data-two-prods');
    var threeAnswers = getProdScores('data-three-prods');
    var fourAnswers = getProdScores('data-four-prods');
    var fiveAnswers = getProdScores('data-five-prods');
    var sixAnswers = getProdScores('data-six-prods');

    var prodOneHandle = '';
    var oneMatched = false;
    var oneMatchedArray = [];
    var oneMatchedWeight = 0;
    for (i=0;i<oneAnswers.length;i++){
      if (!excludeLib.includes(oneAnswers[i].handle)){
        if (oneMatchedWeight == 0){
          oneMatchedWeight = oneAnswers[i].points;
          oneMatchedArray.push(oneAnswers[i].handle);
          console.log("hightest weight: " + oneMatchedWeight);
        }
        else if (oneAnswers[i].points === oneMatchedWeight){
          oneMatchedArray.push(oneAnswers[i].handle);
          console.log(oneAnswers[i].handle + '---' + oneAnswers[i].points);
        }
      }
    }
    
    $('.quizSortProd').each(function(){
      var thisThing = $(this);
      if (oneMatched == false){
        for (i=0;i<oneMatchedArray.length;i++){
          if (thisThing.attr('data-handle') === oneMatchedArray[i]){
            prodOneHandle = oneMatchedArray[i];
            oneMatched = true;
          }
        }
      }
    });

    var prodTwoHandle = '';
    var twoMatched = false;
    var twoMatchedArray = [];
    var twoMatchedWeight = 0;
    for (i=0;i<twoAnswers.length;i++){
      if (!excludeLib.includes(twoAnswers[i].handle)){
        if (twoMatchedWeight == 0){
          twoMatchedWeight = twoAnswers[i].points;
          twoMatchedArray.push(twoAnswers[i].handle);
          console.log("hightest weight: " + twoMatchedWeight);
        }
        else if (twoAnswers[i].points === twoMatchedWeight){
          twoMatchedArray.push(twoAnswers[i].handle);
          console.log(twoAnswers[i].handle + '---' + twoAnswers[i].points);
        }
      }
    }
    
    $('.quizSortProd').each(function(){
      var thisThing = $(this);
      if (twoMatched == false){
        for (i=0;i<twoMatchedArray.length;i++){
          if (thisThing.attr('data-handle') === twoMatchedArray[i]){
            prodTwoHandle = twoMatchedArray[i];
            twoMatched = true;
          }
        }
      }
    });

    var prodThreeHandle = '';
    var threeMatched = false;
    var threeMatchedArray = [];
    var threeMatchedWeight = 0;
    for (i=0;i<threeAnswers.length;i++){
      if (!excludeLib.includes(threeAnswers[i].handle)){
        if (threeMatchedWeight == 0){
          threeMatchedWeight = threeAnswers[i].points;
          threeMatchedArray.push(threeAnswers[i].handle);
          console.log("hightest weight: " + threeMatchedWeight);
        }
        else if (threeAnswers[i].points === threeMatchedWeight){
          threeMatchedArray.push(threeAnswers[i].handle);
          console.log(threeAnswers[i].handle + '---' + threeAnswers[i].points);
        }
      }
    }
    
    $('.quizSortProd').each(function(){
      var thisThing = $(this);
      if (threeMatched == false){
        for (i=0;i<threeMatchedArray.length;i++){
          if (thisThing.attr('data-handle') === threeMatchedArray[i]){
            prodThreeHandle = threeMatchedArray[i];
            threeMatched = true;
          }
        }
      }
    });

    var prodFourHandle = '';
    var fourMatched = false;
    var fourMatchedArray = [];
    var fourMatchedWeight = 0;
    for (i=0;i<fourAnswers.length;i++){
      if (!excludeLib.includes(fourAnswers[i].handle)){
        if (fourMatchedWeight == 0){
          fourMatchedWeight = fourAnswers[i].points;
          fourMatchedArray.push(fourAnswers[i].handle);
          console.log("hightest weight: " + fourMatchedWeight);
        }
        else if (fourAnswers[i].points === fourMatchedWeight){
          fourMatchedArray.push(fourAnswers[i].handle);
          console.log(fourAnswers[i].handle + '---' + fourAnswers[i].points);
        }
      }
    }
    
    $('.quizSortProd').each(function(){
      var thisThing = $(this);
      if (fourMatched == false){
        for (i=0;i<fourMatchedArray.length;i++){
          if (thisThing.attr('data-handle') === fourMatchedArray[i]){
            prodFourHandle = fourMatchedArray[i];
            fourMatched = true;
          }
        }
      }
    });

    var prodFiveHandle = '';
    var fiveMatched = false;
    var fiveMatchedArray = [];
    var fiveMatchedWeight = 0;
    for (i=0;i<fiveAnswers.length;i++){
      if (!excludeLib.includes(fiveAnswers[i].handle)){
        if (fiveMatchedWeight == 0){
          fiveMatchedWeight = fiveAnswers[i].points;
          fiveMatchedArray.push(fiveAnswers[i].handle);
          console.log("hightest weight: " + fiveMatchedWeight);
        }
        else if (fiveAnswers[i].points === fiveMatchedWeight){
          fiveMatchedArray.push(fiveAnswers[i].handle);
          console.log(fiveAnswers[i].handle + '---' + fiveAnswers[i].points);
        }
      }
    }
    
    $('.quizSortProd').each(function(){
      var thisThing = $(this);
      if (fiveMatched == false){
        for (i=0;i<fiveMatchedArray.length;i++){
          if (thisThing.attr('data-handle') === fiveMatchedArray[i]){
            prodFiveHandle = fiveMatchedArray[i];
            fiveMatched = true;
          }
        }
      }
    });

    var prodSixHandle = '';
    var sixMatched = false;
    var sixMatchedArray = [];
    var sixMatchedWeight = 0;
    for (i=0;i<sixAnswers.length;i++){
      if (!excludeLib.includes(sixAnswers[i].handle)){
        if (sixMatchedWeight == 0){
          sixMatchedWeight = sixAnswers[i].points;
          sixMatchedArray.push(sixAnswers[i].handle);
          console.log("hightest weight: " + sixMatchedWeight);
        }
        else if (sixAnswers[i].points === sixMatchedWeight){
          sixMatchedArray.push(sixAnswers[i].handle);
          console.log(sixAnswers[i].handle + '---' + sixAnswers[i].points);
        }
      }
    }
    
    $('.quizSortProd').each(function(){
      var thisThing = $(this);
      if (sixMatched == false){
        for (i=0;i<sixMatchedArray.length;i++){
          if (thisThing.attr('data-handle') === sixMatchedArray[i]){
            prodSixHandle = sixMatchedArray[i];
            sixMatched = true;
          }
        }
      }
    });
/*
    var prodOneHandle = '';
    var oneMatched = false;
    for (i=0;i<oneAnswers.length;i++){
      if (oneMatched == false){
        if (!excludeLib.includes(oneAnswers[i].handle)){
          prodOneHandle = oneAnswers[i].handle;
          oneMatched = true;
        }
      }
    }
    
    var prodTwoHandle = '';
    var twoMatched = false;
    for (i=0;i<twoAnswers.length;i++){
      if (twoMatched == false){
        if (!excludeLib.includes(twoAnswers[i].handle)){
          prodTwoHandle = twoAnswers[i].handle;
          twoMatched = true;
        }
      }
    }

    var prodThreeHandle = '';
    var threeMatched = false;
    for (i=0;i<threeAnswers.length;i++){
      if (threeMatched == false){
        if (!excludeLib.includes(threeAnswers[i].handle)){
          prodThreeHandle = threeAnswers[i].handle;
          threeMatched = true;
        }
      }
    }

    var prodFourHandle = '';
    var fourMatched = false;
    for (i=0;i<fourAnswers.length;i++){
      if (fourMatched == false){
        if (!excludeLib.includes(fourAnswers[i].handle)){
          prodFourHandle = fourAnswers[i].handle;
          fourMatched = true;
        }
      }
    }
    
    var prodFiveHandle = '';
    var fiveMatched = false;
    for (i=0;i<fiveAnswers.length;i++){
      if (fiveMatched == false){
        if (!excludeLib.includes(fiveAnswers[i].handle)){
          prodFiveHandle = fiveAnswers[i].handle;
          fiveMatched = true;
        }
      }
    }
    
    var prodSixHandle = '';
    var sixMatched = false;
    for (i=0;i<sixAnswers.length;i++){
      if (sixMatched == false){
        if (!excludeLib.includes(sixAnswers[i].handle)){
          prodSixHandle = sixAnswers[i].handle;
          sixMatched = true;
        }
      }
    }
    */

    var handleArray = [];
    if (prodOneHandle != ''){
      handleArray.push(prodOneHandle);
    }
    else{
      handleArray.push('empty');
    }
    if (prodTwoHandle != ''){
      handleArray.push(prodTwoHandle);
    }
    else{
      handleArray.push('empty');
    }
    if (prodThreeHandle != ''){
      handleArray.push(prodThreeHandle);
    }
    else{
      handleArray.push('empty');
    }
    if (prodFourHandle != ''){
      handleArray.push(prodFourHandle);
    }
    else{
      handleArray.push('empty');
    }
    if (prodFiveHandle != ''){
      handleArray.push(prodFiveHandle);
    }
    else{
      handleArray.push('empty');
    }
    if (prodSixHandle != ''){
      handleArray.push(prodSixHandle);
    }
    else{
      handleArray.push('empty');
    }
    
    var handlesString = handleArray.join(',');
    return handlesString;
  }

  function getMainConcern(){
    var concernLib = [];
    $('.quizQuestion__radioAnswer--active, .quizQuestion__selectAnswer--active').each(function(){
      var weight = $(this).attr('data-weight') * 1;
      if ($(this).attr('data-concern').trim() != ''){
        var handle = $(this).attr('data-concern');
        if (checkArrayForHandle(concernLib, handle)){
          var result = concernLib.filter(obj => {
            return obj.handle === handle
          });
          result.points += weight;
        }
        else{
          var prodObj = {
            handle: handle,
            points: weight
          };
          concernLib.push(prodObj);
        }
      }
    });
    
    if (concernLib.length > 0){
      concernLib.sort((a, b) => parseFloat(a.points) - parseFloat(b.points));
      concernLib.reverse();
      var mainConcern = concernLib[0].handle;
      if (mainConcern == "empty"){
        mainConcern = concernLib[1].handle;
      }
      
    }
    else{
      var mainConcern = 'false';
    }
    
    return mainConcern;
  }

  $('.quizControls__button--skip').on('click', function(){
    window.location.href = '/pages/quiz-results?prods='+getRecommendedProducts()+'&concern='+getMainConcern();
  });

  $('.quizControls__button--skip').on('mouseenter', function(){
    console.log(getRecommendedProducts());
  });

  $( document ).ready(function() {
    
    if ($('#shopify-section-quizResults').length >= 1){
      
      var urlParams = new URLSearchParams(window.location.search);
      var prods = urlParams.get('prods').split(',');
      var concern = urlParams.get('concern');
      console.log(prods);
      console.log(concern);

      var prodOne = 'pre';
      if (prods[0] != 'empty'){
        jQuery.getJSON(window.Shopify.routes.root + 'products/'+prods[0]+'.js', function(product) {
          prodOne = {
            handle: product.handle,
            title: product.title,
            text: product.description,
            image: product.featured_image,
            price: product.price,
            oldPrice: product.compare_at_price_max,
            id: product.id,
            variantId: product.variants[0].id
          };
        });
      }
      else{
        prodOne = "empty";
      }

      var prodTwo = 'pre';
      if (prods[1] != 'empty'){
        jQuery.getJSON(window.Shopify.routes.root + 'products/'+prods[1]+'.js', function(product) {
          prodTwo = {
            handle: product.handle,
            title: product.title,
            text: product.description,
            image: product.featured_image,
            price: product.price,
            oldPrice: product.compare_at_price_max,
            id: product.id,
            variantId: product.variants[0].id
          };
        });
      }
      else{
        prodTwo = "empty";
      }

      var prodThree = 'pre';
      if (prods[2] != 'empty'){
        jQuery.getJSON(window.Shopify.routes.root + 'products/'+prods[2]+'.js', function(product) {
          prodThree = {
            handle: product.handle,
            title: product.title,
            text: product.description,
            image: product.featured_image,
            price: product.price,
            oldPrice: product.compare_at_price_max,
            id: product.id,
            variantId: product.variants[0].id
          };
        });
      }
      else{
        prodThree = "empty";
      }

      var prodFour = 'pre';
      if (prods[3] != 'empty'){
        jQuery.getJSON(window.Shopify.routes.root + 'products/'+prods[3]+'.js', function(product) {
          prodFour = {
            handle: product.handle,
            title: product.title,
            text: product.description,
            image: product.featured_image,
            price: product.price,
            oldPrice: product.compare_at_price_max,
            id: product.id,
            variantId: product.variants[0].id
          };
        });
      }
      else{
        prodFour = "empty";
      }

      var prodFive = 'pre';
      if (prods[4] != 'empty'){
        jQuery.getJSON(window.Shopify.routes.root + 'products/'+prods[4]+'.js', function(product) {
          prodFive = {
            handle: product.handle,
            title: product.title,
            text: product.description,
            image: product.featured_image,
            price: product.price,
            oldPrice: product.compare_at_price_max,
            id: product.id,
            variantId: product.variants[0].id
          };
        });
      }
      else{
        prodFive = "empty";
      }

      var prodSix = 'pre';
      if (prods[5] != 'empty'){
        jQuery.getJSON(window.Shopify.routes.root + 'products/'+prods[5]+'.js', function(product) {
          prodSix = {
            handle: product.handle,
            title: product.title,
            text: product.description,
            image: product.featured_image,
            price: product.price,
            oldPrice: product.compare_at_price_max,
            id: product.id,
            variantId: product.variants[0].id
          };
        });
      }
      else{
        prodSix = "empty";
      }

      var getProdDataInterval = setInterval(function(){
        if (typeof $BV === "undefined"){
          
        }
        else{
          if (prodOne != 'pre' && prodTwo != 'pre' && prodThree != 'pre' && prodFour != 'pre' && prodFive != 'pre' && prodSix != 'pre'){
            clearInterval(getProdDataInterval);
            console.log(prodOne);
            console.log(prodTwo);
            console.log(prodThree);
            console.log(prodFour);
            console.log(prodFive);
            console.log(prodSix);
            populateResults();
            $('.quizResults__loading').fadeOut();
          }
        }
      }, 10);

      function populateResults(){
        var stepOne = $('.resultCard--first');
        var stepTwo = $('.resultCard--second');
        var stepThree = $('.resultCard--third');
        var stepFour = $('.resultCard--fourth');
        var stepFive = $('.resultCard--fifth');
        var stepSix = $('.resultCard--sixth');

        if (prodOne != 'empty'){
          stepOne.attr('data-handle', prodOne.handle);
          stepOne.find('.resultCard__image').attr('src', prodOne.image).attr('alt', prodOne.title);
          stepOne.find('.resultsCard__title').text(prodOne.title);
          //stepOne.find('.resultsCard__text').html(prodOne.text);
          stepOne.find('.resultsCard__price').text('$'+((prodOne.price / 100).toFixed(2)));
          if (prodOne.oldPrice > prodOne.price){
            stepOne.find('.resultsCard__priceOld').text('$'+((prodOne.oldPrice / 100).toFixed(2)));
          }
          else{
            stepOne.find('.resultsCard__priceOld').hide();
          }
          stepOne.find('.resultsCard__reviews div').attr('data-bv-product-id', prodOne.id).attr('data-bv-redirect-url', '/products/'+prodOne.handle);
          $BV.ui("rr", "show_reviews", {productId: prodOne.id});
          stepOne.find('.resultsCard__selectItem').attr('data-id', prodOne.variantId);
        }
        else{
          stepOne.hide();
        }

        if (prodTwo != 'empty'){
          stepTwo.attr('data-handle', prodTwo.handle);
          stepTwo.find('.resultCard__image').attr('src', prodTwo.image).attr('alt', prodTwo.title);
          stepTwo.find('.resultsCard__title').text(prodTwo.title);
          //stepTwo.find('.resultsCard__text').html(prodTwo.text);
          stepTwo.find('.resultsCard__price').text('$'+((prodTwo.price / 100).toFixed(2)));
          if (prodTwo.oldPrice > prodTwo.price){
            stepTwo.find('.resultsCard__priceOld').text('$'+((prodTwo.oldPrice / 100).toFixed(2)));
          }
          else{
            stepTwo.find('.resultsCard__priceOld').hide();
          }
          stepTwo.find('.resultsCard__reviews div').attr('data-bv-product-id', prodTwo.id).attr('data-bv-redirect-url', '/products/'+prodTwo.handle);
          $BV.ui("rr", "show_reviews", {productId: prodTwo.id});
          stepTwo.find('.resultsCard__selectItem').attr('data-id', prodTwo.variantId);
        }
        else{
          stepTwo.hide();
        }

        if (prodThree != 'empty'){
          stepThree.attr('data-handle', prodThree.handle);
          stepThree.find('.resultCard__image').attr('src', prodThree.image).attr('alt', prodThree.title);
          stepThree.find('.resultsCard__title').text(prodThree.title);
          //stepThree.find('.resultsCard__text').html(prodThree.text);
          stepThree.find('.resultsCard__price').text('$'+((prodThree.price / 100).toFixed(2)));
          if (prodThree.oldPrice > prodThree.price){
            stepThree.find('.resultsCard__priceOld').text('$'+((prodThree.oldPrice / 100).toFixed(2)));
          }
          else{
            stepThree.find('.resultsCard__priceOld').hide();
          }
          stepThree.find('.resultsCard__reviews div').attr('data-bv-product-id', prodThree.id).attr('data-bv-redirect-url', '/products/'+prodThree.handle);
          $BV.ui("rr", "show_reviews", {productId: prodThree.id});
          stepThree.find('.resultsCard__selectItem').attr('data-id', prodThree.variantId);
        }
        else{
          stepThree.hide();
        }

        if (prodFour != 'empty'){
          stepFour.attr('data-handle', prodFour.handle);
          stepFour.find('.resultCard__image').attr('src', prodFour.image).attr('alt', prodFour.title);
          stepFour.find('.resultsCard__title').text(prodFour.title);
          //stepFour.find('.resultsCard__text').html(prodFour.text);
          stepFour.find('.resultsCard__price').text('$'+((prodFour.price / 100).toFixed(2)));
          if (prodFour.oldPrice > prodFour.price){
            stepFour.find('.resultsCard__priceOld').text('$'+((prodFour.oldPrice / 100).toFixed(2)));
          }
          else{
            stepFour.find('.resultsCard__priceOld').hide();
          }
          stepFour.find('.resultsCard__reviews div').attr('data-bv-product-id', prodFour.id).attr('data-bv-redirect-url', '/products/'+prodFour.handle);
          $BV.ui("rr", "show_reviews", {productId: prodFour.id});
          stepFour.find('.resultsCard__selectItem').attr('data-id', prodFour.variantId);
        }
        else{
          stepFour.hide();
        }

        if (prodFive != 'empty'){
          stepFive.attr('data-handle', prodFive.handle);
          stepFive.find('.resultCard__image').attr('src', prodFive.image).attr('alt', prodFive.title);
          stepFive.find('.resultsCard__title').text(prodFive.title);
          //stepFive.find('.resultsCard__text').html(prodFive.text);
          stepFive.find('.resultsCard__price').text('$'+((prodFive.price / 100).toFixed(2)));
          if (prodFive.oldPrice > prodFive.price){
            stepFive.find('.resultsCard__priceOld').text('$'+((prodFive.oldPrice / 100).toFixed(2)));
          }
          else{
            stepFive.find('.resultsCard__priceOld').hide();
          }
          stepFive.find('.resultsCard__reviews div').attr('data-bv-product-id', prodFive.id).attr('data-bv-redirect-url', '/products/'+prodFive.handle);
          $BV.ui("rr", "show_reviews", {productId: prodFive.id});
          stepFive.find('.resultsCard__selectItem').attr('data-id', prodFive.variantId);
        }
        else{
          stepFive.hide();
        }

        if (prodSix != 'empty'){
          stepSix.attr('data-handle', prodSix.handle);
          stepSix.find('.resultCard__image').attr('src', prodSix.image).attr('alt', prodSix.title);
          stepSix.find('.resultsCard__title').text(prodSix.title);
          //stepSix.find('.resultsCard__text').html(prodSix.text);
          stepSix.find('.resultsCard__price').text('$'+((prodSix.price / 100).toFixed(2)));
          if (prodSix.oldPrice > prodSix.price){
            stepSix.find('.resultsCard__priceOld').text('$'+((prodSix.oldPrice / 100).toFixed(2)));
          }
          else{
            stepSix.find('.resultsCard__priceOld').hide();
          }
          stepSix.find('.resultsCard__reviews div').attr('data-bv-product-id', prodSix.id).attr('data-bv-redirect-url', '/products/'+prodSix.handle);
          $BV.ui("rr", "show_reviews", {productId: prodSix.id});
          stepSix.find('.resultsCard__selectItem').attr('data-id', prodSix.variantId);
        }
        else{
          stepSix.hide();
        }

        for (i=0;i<benefitLib.length;i++){
          $('.resultCard[data-handle="'+benefitLib[i].product+'"]').find('.resultsCard__text').html(benefitLib[i].benefit);
        }
        
      }
    }

    $('[data-concern="'+concern+'"').show();
  });

  $('.quizResults__buyButton').on('click', function(){
    var prodArray = [];
    $('.resultsCard__selectItem').each(function(){
      var variantId = $(this).attr('data-id') * 1;
      if (variantId !== 0) {
        var prodObj = {
          id: variantId,
          quantity: 1
        }
        prodArray.push(prodObj);
      }
    });
    console.log("prodArray:");
    console.log(prodArray);
    CartJS.addItems(prodArray, {
      "success": function(data, textStatus, jqXHR) {
        CartJS.getNote();
        console.log("data:");
        console.log(data); // console.log(CartJS.cart);

        $(".modal-quick-view").hide();

        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
        } else {
          window.location = "/cart";
        }
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log('Error: ' + errorThrown + '!');
      }
    });
  });

  $('.resultsCard__selectItem').on('click', function(){
    if ($(this).hasClass("resultsCard__selectItem--added")){
      return;
    }
    var thisThing = $(this);
    var variantId = thisThing.attr('data-id') * 1;
    CartJS.addItem(variantId, 1, {}, {
      "success": function(data, textStatus, jqXHR) {
        CartJS.getNote();
        console.log(data); // console.log(CartJS.cart);

        $(".modal-quick-view").hide();

        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
          thisThing.addClass('resultsCard__selectItem--added');
          thisThing.find('.resultsCard__selectedItemDefault').hide();
          thisThing.find('.resultsCard__selectedItemSelected').show();
        } else {
          window.location = "/cart";
        }
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log('Error: ' + errorThrown + '!');
      }
    });
  });

  

  $('.quizButton--submit').on('click', function(){
    var email = $('.quizQuestion__klaviyoInput').val();
    var allAnswerStringArray = [];

    $('.quizSlide').each(function(){
      var thisThing = $(this);
      if (thisThing.attr('data-slide') != "0" && thisThing.attr('data-slide') != "12"){
        var subStringArray = [];
        thisThing.find('.quizQuestion__radioAnswer--active, quizQuestion__selectAnswer--active').each(function(){
          subStringArray.push($(this).text());
        });
        var subString = subStringArray.join('|');
      }
      allAnswerStringArray.push(subString);
    });
    var allAnswerString = allAnswerStringArray.join(',');

    var url = '/pages/quiz-results?prods='+getRecommendedProducts()+'&concern='+getMainConcern();
    
    var settings = getKlaviyoSettings(email, allAnswerString, url);
    $.ajax(settings).done(function(response) {
      console.log(response);
      window.location.href = url;
    });
  });

  function getKlaviyoSettings(email, answers, url){
    var answerArray = answers.split(',');
        
    var settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
        },
      "data": {
        "g": "UUgy4W", // replace LIST_ID with id of list to be subscribed
        "email": email,
        "$fields": "$source, $results_url, $answer_one, $answer_two, $answer_three, $answer_four, $answer_five, $answer_six, $answer_seven, $answer_eight, $answer_nine, $answer_ten, $answer_eleven",
        "$source": "Quiz Submission",
        "$results_url": url,
        "$answer_one": answerArray[0],
        "$answer_two": answerArray[1],
        "$answer_three": answerArray[2],
        "$answer_four": answerArray[3],
        "$answer_five": answerArray[4],
        "$answer_six": answerArray[5],
        "$answer_seven": answerArray[6],
        "$answer_eight": answerArray[7],
        "$answer_nine": answerArray[8],
        "$answer_ten": answerArray[9],
        "$answer_eleven": answerArray[10]
      }
    };
    return settings;
  }

  const resultsSlider = new Swiper('.quizResults__prodSliderWrapper', {
    slidesPerView: 1,
    spaceBetween: 16,
    centerInsufficientSlides: true,
    threshold: 10,
    navigation: {
      nextEl: '.resultsSlider__nextButton',
      prevEl: '.resultsSlider__prevButton',
      disabledClass: 'resultsSlider__button--disabled'
    },
    breakpoints: {
      1000: {
        slidesPerView: 4
      }
    }
  });

});







document.querySelector('.static-reviews-text-el').addEventListener('click', function () {
  const target = document.querySelector('.custom_review-main');
  if (target) {
    const offset = 100;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }
});




document.querySelectorAll('.scroll-on-product-section').forEach(button => {
button.addEventListener('click', function (e) {
  e.preventDefault();
  const target = document.querySelector('#product');
  const offset = -100;
  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset + offset;
  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
});
});



document.addEventListener('click', function (e) {
  const btn = e.target.closest('.go-to-checkout-btn');
  if (!btn) return;

  e.preventDefault();

  btn.classList.add('active-btn');

  const cart = document.querySelector('#CartSidebar');
  const overlay = document.querySelector('#cart_overlay');

  if (cart) cart.style.display = 'none';
  if (overlay) overlay.style.display = 'none';

  const atcButton = document.querySelector(
    '.add-to-cart.js__pdp-button-section button#add-primary'
  );

  if (atcButton) atcButton.click();

  const observer = new MutationObserver(() => {
    const isCartActive = document
      .querySelector('#CartSidebar')
      ?.classList.contains('active');

    if (isCartActive) {
      observer.disconnect();

      btn.classList.remove('active-btn');

      window.location.href = '/checkout';
    }
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});




